<h1 mat-dialog-title>{{ 'LINK_DIALOG.TITLE' | translate }}</h1>

<div mat-dialog-content>
  <p class="direct-call-info">{{ 'LINK_DIALOG.INFO' | translate }}</p>

  <div class="link-notification-mode-selector">
    <div class="link-notification-mode-item mode-sms" [ngClass]="{ selected: mode === InvitationMode.Sms }" (click)="setMode(InvitationMode.Sms)">
      <p><i class="fa-regular fa-comment"></i> {{ 'SMS' | translate }} </p>
    </div>

    <div class="link-notification-mode-item mode-email" [ngClass]="{ selected: mode === InvitationMode.Email }" (click)="setMode(InvitationMode.Email)">
      <p><i class="fa-regular fa-envelope"></i> {{ 'Email' | translate }}</p>
    </div>

    <div class="link-notification-mode-item mode-link" [ngClass]="{ selected: mode === InvitationMode.Link }" (click)="setMode(InvitationMode.Link)">
      <p><i class="fa-solid fa-link"></i> {{ 'Link' | translate }}</p>
    </div>
  </div>

  <div class="notification-mode-input">

    <div [hidden]="mode !== InvitationMode.Sms">
      <div class="sms-row">
        <mat-form-field class="phone-prefix-field">
          <input type="text" matInput [(ngModel)]="smsPrefix" #smsPrefixRef="ngModel" [matAutocomplete]="auto" (focus)="onAutocompleteOpened()" [placeholder]="'ADD_CONTACT_DIALOG.PREFIX' | translate">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayPrefix.bind(this)">
            @for (prefix of filteredPrefixes; track prefix.dial_code) {
            <mat-option [value]="prefix">{{prefix.display}}</mat-option>
            }
          </mat-autocomplete>
          @if (smsPrefixRef.invalid) {
          <mat-error>
            @if (smsPrefixRef.errors?.['phonePrefixRequired']) {
            <span>{{'ADD_CONTACT_DIALOG.ERROR.PHONE_PREFIX_REQUIRED' | translate}}</span>
            }
          </mat-error>
          }

        </mat-form-field>

        <mat-form-field class="phone-number-field">
          <input matInput type="tel" class="input-item phone-input" [(ngModel)]="smsNumber" name="smsNumber" #smsNumberRef="ngModel" [placeholder]="'LINK_DIALOG.PLACEHOLDER_PHONE_NUMBER' | translate" (focus)="clearError()">
          @if (smsNumberRef.invalid && smsNumberRef.touched) {
          <mat-error>
            @if (smsNumberRef.errors?.['phoneInvalid']) {
            <span>{{'MODAL.INVALID_PHONE' | translate}}</span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="email-row" [hidden]="mode !== InvitationMode.Email">
      <mat-form-field style="display:inline">
        <input matInput type="email" class="input-item" [(ngModel)]="email" name="email" #emailRef="ngModel" [placeholder]="'LINK_DIALOG.PLACEHOLDER_EMAIL' | translate" (focus)="clearError()">
        @if (emailRef.invalid && emailRef.touched) {
        <mat-error>
          @if (emailRef.errors?.['email']) {
          <span>{{'MODAL.INVALID_EMAIL' | translate}}</span>
          }
        </mat-error>
        }
      </mat-form-field>

    </div>

    @if (shouldShowError()) {
    <div class="form-validation-error">
      <span>{{ errorMessage }}</span>
    </div>
    }
  </div>

<div mat-dialog-actions align="end">

  <button mat-button [mat-dialog-close]="false">{{'MODAL.CANCEL' | translate}}</button>

  @if (mode === 'link') {
    <button mat-button (click)="copyLink()">{{ 'LINK_DIALOG.COPY_LINK' | translate }}</button>
  }

  @if (mode === 'sms') {
    <button mat-button (click)="sendSMS()">{{ 'MODAL.SEND' | translate }}</button>
  }

  @if (mode === 'email') {
    <button mat-button (click)="sendEmail()">{{ 'MODAL.SEND' | translate }}</button>
  }
</div>
